var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-8",staticStyle:{"margin-left":"20%"}},[_c('br'),_c('br'),_c('br'),_c('br'),_c('div',{staticClass:"alert alert-success",attrs:{"role":"alert"}},[_vm._v("\n        Έχετε αποσυνδεθεί με επιτυχία. Θα ανακατευθυνθείτε στην σελίδα σύνδεσης σε 3 δευτερόλεπτα.\n    ")])])
}]

export { render, staticRenderFns }